import { render, staticRenderFns } from "./ManageGiftCertificateSales.vue?vue&type=template&id=1645e9b2"
import script from "./ManageGiftCertificateSales.vue?vue&type=script&lang=ts"
export * from "./ManageGiftCertificateSales.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports